import '@ssml-editor/core';
import '@ssml-editor/vue';
import '../../module/phoneme/alphabet.enum.js';
import { SayAsInterpretation } from '../../module/say-as/say-as-interpretation.enum.js';
import '@ssml-editor/modules';
import '../../module/speak/effect.enum.js';
import '../../../node_modules/.pnpm/slate-vue3@0.13.2_vue@3.5.31_typescript@5.9.3_/node_modules/slate-vue3/dist/create-editor-z7CFqjGE.js';
import 'vue';
import 'element-plus';
/* empty css                                                                                                                                           */
/* empty css                                                                                                                                                */
/* empty css                                                                                                                                                 */
/* empty css                                                                                                                                                */
/* empty css                                                                                                                                                   */
/* empty css                                                     */
/* empty css                                                                                                                                                */
/* empty css                                                                                                                                                 */
/* empty css                                     */
/* empty css                                                                                                                                              */
/* empty css                                                                                                                                               */
import '@ssml-editor/base';
/* empty css                                                                                                                                                 */
/* empty css                                                                                                                                                      */
/* empty css                                                                                                                                                */
/* empty css                      */
import 'cmu-pronouncing-dictionary';
/* empty css                          */
import '../../../node_modules/.pnpm/slate-vue3@0.13.2_vue@3.5.31_typescript@5.9.3_/node_modules/slate-vue3/dist/hotkeys-BEBL6MB3.js';
/* empty css                        */
/* empty css                */
import '@element-plus/icons-vue';
/* empty css                                     */
import '../../../_virtual/lodash.js';
/* empty css                                                                                                                                             */
/* empty css                       */
/* empty css                         */
/* empty css                     */
/* empty css                                  */
/* empty css                             */
/* empty css                         */
import '../voice/voice-menu.vue.js';

const SayAsInterpretationData = {
  [SayAsInterpretation.CARDINAL]: "读数值",
  [SayAsInterpretation.DIGITS]: "读数字",
  [SayAsInterpretation.TELEPHONE]: "读手机号",
  [SayAsInterpretation.NAME]: "读人名",
  [SayAsInterpretation.ADDRESS]: "读地址",
  [SayAsInterpretation.ID]: "读账号",
  [SayAsInterpretation.CHARACTERS]: "读字符",
  [SayAsInterpretation.PUNCTUATION]: "读符号",
  [SayAsInterpretation.DATE]: "读日期",
  [SayAsInterpretation.TIME]: "读时间",
  [SayAsInterpretation.CURRENCY]: "读金额",
  [SayAsInterpretation.MEASURE]: "读单位"
};

export { SayAsInterpretationData };
//# sourceMappingURL=constant.js.map
